import { BrowserRouter, Navigate, Route, Routes, useLocation } from "react-router-dom";
import { AuthProvider } from "./auth/AuthContext";
import { useAuth } from "./auth/useAuth";
import { AuditLogPage } from "./pages/AuditLogPage";
import { BitrixHealthPage } from "./pages/BitrixHealthPage";
import { DispatchDetailPage } from "./pages/DispatchDetailPage";
import { DispatchesPage } from "./pages/DispatchesPage";
import { DocumentDetailPage } from "./pages/DocumentDetailPage";
import { DocumentsPage } from "./pages/DocumentsPage";
import { ExtensionHealthPage } from "./pages/ExtensionHealthPage";
import { LoginPage } from "./pages/LoginPage";
import { PrivacyErasurePage } from "./pages/PrivacyErasurePage";
import { ReportsPage } from "./pages/ReportsPage";
import { SettingsPage } from "./pages/SettingsPage";
import { UserDetailPage } from "./pages/UserDetailPage";
import { UsersPage } from "./pages/UsersPage";
import { AppLayout } from "./widgets/AppLayout";

function Loading() {
  return (
    <div className="min-h-screen flex items-center justify-center text-muted-foreground">
      Загрузка…
    </div>
  );
}

function ProtectedLayout() {
  const { status } = useAuth();
  const location = useLocation();
  if (status === "loading") return <Loading />;
  if (status === "unauthenticated") {
    return <Navigate to="/login" replace state={{ from: location.pathname }} />;
  }
  return <AppLayout />;
}

function LoginRoute() {
  const { status } = useAuth();
  const location = useLocation();
  if (status === "loading") return <Loading />;
  if (status === "authenticated") {
    const from = (location.state as { from?: string } | null)?.from ?? "/users";
    return <Navigate to={from} replace />;
  }
  return <LoginPage />;
}

export default function App() {
  return (
    <BrowserRouter>
      <AuthProvider>
        <Routes>
          <Route path="/login" element={<LoginRoute />} />
          <Route element={<ProtectedLayout />}>
            <Route path="/" element={<Navigate to="/documents" replace />} />
            <Route path="/documents" element={<DocumentsPage />} />
            <Route path="/documents/:id" element={<DocumentDetailPage />} />
            <Route path="/dispatches" element={<DispatchesPage />} />
            <Route path="/dispatches/:id" element={<DispatchDetailPage />} />
            <Route path="/users" element={<UsersPage />} />
            <Route path="/users/:id" element={<UserDetailPage />} />
            <Route path="/reports" element={<ReportsPage />} />
            <Route path="/bitrix" element={<BitrixHealthPage />} />
            <Route path="/extension-health" element={<ExtensionHealthPage />} />
            <Route path="/privacy" element={<PrivacyErasurePage />} />
            <Route path="/audit-log" element={<AuditLogPage />} />
            <Route path="/settings" element={<SettingsPage />} />
            <Route path="*" element={<Navigate to="/documents" replace />} />
          </Route>
        </Routes>
      </AuthProvider>
    </BrowserRouter>
  );
}
